export default{
    // 是否为中文
    isChinese (val) {
        return /^[\u4e00-\u9fa5]+$/.test(val)
    },
    // 是否为手机号码
    isPhone (val) {
        return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(val)
    }
}